/**
 * =============================================================================
 * Hook do luot hien thi icon chien dich Thadingyut 2026 — ShweDeal
 * Nguon: sheet 12_KB_Event ba dich vu, event view_promotion (P0)
 *
 * Ban view_promotion khi icon dat nguong hien thi hop le: 50% dien tich,
 * lien tuc 1 giay.
 *
 * KHONG ban khi (theo sheet 12):
 *  - icon nam ngoai vung nhin thay (khay SocialLinks dang thu gon)
 *  - chi cuon qua lai trong CUNG mot lan hien thi
 *  - tab bi an hoac app chay nen
 *  - luot nhanh qua chua du 1 giay
 *
 * Cach dem phu thuoc co IMPRESSION_ONCE_PER_PAGE trong thadingyut.js:
 *  - true  : MOT lan moi luot vao trang Home. Khay tu thu gon sau 4 giay va
 *            nguoi dung keo mo/dong nhieu lan la hanh vi cua giao dien, khong
 *            phai cua nguoi dung -> khong dem lai.
 *  - false : dem moi lan icon roi khoi roi vao lai (dung nguyen van TC-01).
 *
 * PHAI dung IntersectionObserver. Dung scroll listener se ban trung hang chuc
 * lan moi giay va TC-01 rot ngay.
 * =============================================================================
 */
import { useEffect, useRef } from "react";
import {
  thdPush,
  platformType,
  SLOT,
  VIEW_RATIO,
  VIEW_DWELL,
  IMPRESSION_ONCE_PER_PAGE,
} from "./thadingyut";

/**
 * @param {React.RefObject<HTMLElement>} ref phan tu icon
 * @param {boolean} enabled chi true voi icon chien dich Thadingyut
 */
export default function useThadingyutImpression(ref, enabled) {
  const seen = useRef(false); // da ban cho lan hien thi hien tai
  const timer = useRef(null);

  useEffect(() => {
    if (!enabled) return undefined;

    const el = ref.current;
    if (!el) return undefined;
    if (typeof IntersectionObserver === "undefined") return undefined;

    const clearTimer = () => {
      if (timer.current) {
        clearTimeout(timer.current);
        timer.current = null;
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const visible =
            entry.isIntersecting && entry.intersectionRatio >= VIEW_RATIO;

          if (visible) {
            if (seen.current || timer.current) return;
            timer.current = setTimeout(() => {
              timer.current = null;
              // tab an / app chay nen: viewport co nhung nguoi dung khong thay
              if (
                typeof document !== "undefined" &&
                document.visibilityState !== "visible"
              ) {
                return;
              }
              seen.current = true;
              thdPush("view_promotion", {
                creative_slot: SLOT.HOME_ICON,
                platform_type: platformType(),
              });
            }, VIEW_DWELL);
          } else {
            clearTimer();
            // Khay thu gon lai -> chi mo cong cho lan dem sau khi duoc phep
            if (!IMPRESSION_ONCE_PER_PAGE) seen.current = false;
          }
        });
      },
      { threshold: [0, VIEW_RATIO, 1] }
    );

    observer.observe(el);

    // An tab trong luc dang dem 1 giay -> huy, khong tinh la da thay
    const onVisibility = () => {
      if (document.visibilityState !== "visible") clearTimer();
    };
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      clearTimer();
      observer.disconnect();
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [ref, enabled]);
}
